import { Component, Injectable } from '@angular/core';
import { NgbCalendar, NgbDateParserFormatter, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { RestService } from '../../master-services/Rest/rest.service';
import { ForkliftService } from '../../master-services/Forklift/forklift.service';
import { UserService } from '../../master-services/User/user.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';

const I18N_VALUES = {
  'fr': {
    weekdays: ['Lun', 'Mar', 'Mié', 'Juv', 'Vie', 'Sáb', 'Dom'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Agos', 'Sep', 'Oct', 'Nov', 'Dic'],
  }
  // other languages you would support
};

@Injectable()
export class I18n {
  language = 'fr';
}

@Component({
  selector: 'app-master-presettlement-all',
  templateUrl: './master-presettlement-all.component.html',
  styleUrls: ['./master-presettlement-all.component.scss',
  '../../../assets/icon/icofont/css/icofont.scss'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: MasterPresettlementAllComponent }]
})
export class MasterPresettlementAllComponent extends NgbDatepickerI18n {

  rowsClient: any;
  rowsUser: any;

  customers: any;
  forklifts: any;

  branchOffices: any;

  fromDate: NgbDateStruct;
  untilDate: NgbDateStruct;
  today = this.calendar.getToday();

  considerDate = true;

  selectedBusinessId: any = 0;
  selectedBranchOfficeId: any = 0;
  selectedUserId: any = 0;
  selectedForkliftId: any = 0;

  part: any = '';
  codepart: any = '';
  numberPresettlement: any = '';

  constructor(private restService: RestService, private _i18n: I18n, private router: Router,
    private forkliftService: ForkliftService, private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter, private userService: UserService) {
    super();

    const date = new Date();
    const ngbDateStruct = { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() };

    this.fromDate = ngbDateStruct;
    this.untilDate = ngbDateStruct;

    this.getUser();
    this.loadingData();
    this.getCustomers();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }

  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }

  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  loadingData() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    this.getPresettlementFiltersInitial();
  }

  getUser() {
    swal({
      title: 'Obteniendo información ...',
      allowOutsideClick: false
    });
    swal.showLoading();
    this.userService.getUsers().then(data => {
      const resp: any = data;
      if (resp.error) {
        swal({
          title: 'Error',
          text: 'Ha ocurrido un error',
          type: 'error'
        });
      } else {
        swal.close();
        this.rowsUser = resp.data;
      }
    }).catch(error => {
      swal.close();
      swal({
        title: 'Error',
        text: 'Ha ocurrido un error',
        type: 'error'
      });
      console.log(error);
    });
  }

  getCustomers() {
    this.restService.getCustomer().then(data => {
      const resp: any = data;
      swal.close();
      this.customers = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }

  getBranchOffices() {
    if (this.selectedBusinessId != 0) {
      this.restService.getOffice(this.selectedBusinessId).then(data => {
        const resp: any = data;
        swal.close();
        this.branchOffices = resp.data;
      }).catch(error => {
        console.log(error);
      });
    } else {
      this.selectedBranchOfficeId = 0;
      this.selectedForkliftId = 0;
    }
  }

  getForklifs() {
    if (this.selectedBranchOfficeId != 0) {
      this.forkliftService.getForkliftBranchOfficesFull(this.selectedBranchOfficeId).then(data => {
        const resp: any = data;
        swal.close();
        this.forklifts = resp.data;
      }).catch(error => {
        console.log(error);
      });
    } else {
      this.selectedForkliftId = 0;
    }
  }

  changeConsiderDate(event: any) {
    this.considerDate = !this.considerDate;
  }

  onDateSelectionFrom(date: any) {
    if (this.untilDate) {
      const fromD = new Date(this.fromDate.year, this.fromDate.month, this.fromDate.day);
      const untilD = new Date(this.untilDate.year, this.untilDate.month, this.untilDate.day);

      if (fromD > untilD) {
        this.untilDate = this.fromDate;
      }
    }
  }

  onDateSelectionUntil(date: any) {
    const fromD = new Date(this.fromDate.year, this.fromDate.month, this.fromDate.day);
    const untilD = new Date(this.untilDate.year, this.untilDate.month, this.untilDate.day);

    if (untilD < fromD) {
      this.fromDate = this.untilDate;
    }
  }

  getPresettlementFilters() {

    if (this.considerDate == false && this.selectedBusinessId == 0 && this.part == 0 &&
      this.codepart == 0 && this.numberPresettlement == 0 && this.selectedForkliftId == 0 &&
      this.selectedUserId == 0 && this.selectedBranchOfficeId == 0) {
      swal({
        title: 'Importante',
        text: 'Debes seleccionar por lo menos uno de los filtros o activar casilla para tener en cuenta las fechas',
        type: 'error'
      });
    } else {
      swal({
        title: 'Validando información ...',
        allowOutsideClick: false
      });
      swal.showLoading();

      const params = this.buildPresettlementParams();
      this.loadPresettlements(params);
    }
  }

  getPresettlementFiltersInitial() {

    var day = (this.fromDate.day < 10 ? '0' : '') + this.fromDate.day;
    let month = ((this.fromDate.month) < 10 ? '0' : '') + (this.fromDate.month);
    var year = this.fromDate.year;

    var dayUntil = (this.untilDate.day < 10 ? '0' : '') + this.untilDate.day;
    let monthUntil = ((this.untilDate.month) < 10 ? '0' : '') + (this.untilDate.month);
    var yearUntil = this.untilDate.year;

    var fromD = year + '-' + month + '-' + day;
    var untilD = yearUntil + '-' + monthUntil + '-' + dayUntil;

    const params = 'from_date=' + fromD + ' 00:00:00' + '&&' + 'to_date=' + untilD + ' 23:59:59';

    this.loadPresettlements(params);
  }

  buildPresettlementParams() {
    let params = '';
    let cont = 0;

    if (this.considerDate) {

      var day = (this.fromDate.day < 10 ? '0' : '') + this.fromDate.day;
      let month = ((this.fromDate.month) < 10 ? '0' : '') + (this.fromDate.month);
      var year = this.fromDate.year;

      var dayUntil = (this.untilDate.day < 10 ? '0' : '') + this.untilDate.day;
      let monthUntil = ((this.untilDate.month) < 10 ? '0' : '') + (this.untilDate.month);
      var yearUntil = this.untilDate.year;

      var fromD = year + '-' + month + '-' + day;
      var untilD = yearUntil + '-' + monthUntil + '-' + dayUntil;

      const fromLocal = fromD + " 00:00:00";
      const toLocal = untilD + " 23:59:59";

      const fromUTC = this.toUTC(fromLocal);
      const toUTC = this.toUTC(toLocal);

      params = "from_date=" + fromUTC + "&&" + "to_date=" + toUTC;
      cont++;
    }

    if (this.selectedBusinessId != 0) {
      if (cont > 0) {
        params = params + '&&customer_id=' + this.selectedBusinessId;
      } else {
        params = params + 'customer_id=' + this.selectedBusinessId;
        cont++;
      }
    }

    if (this.part != '') {
      if (cont > 0) {
        params = params + '&&description_query=' + this.part;
      } else {
        params = params + 'description_query=' + this.part;
        cont++;
      }
    }

    if (this.codepart != '') {
      if (cont > 0) {
        params = params + '&&codepart_query=' + this.codepart;
      } else {
        params = params + 'codepart_query=' + this.codepart;
        cont++;
      }
    }

    if (this.numberPresettlement != '') {
      if (cont > 0) {
        params = params + '&&consecutive=' + this.numberPresettlement;
      } else {
        params = params + 'consecutive=' + this.numberPresettlement;
        cont++;
      }
    }

    if (this.selectedForkliftId != 0) {
      if (cont > 0) {
        params = params + '&&forklift_id=' + this.selectedForkliftId;
      } else {
        params = params + 'forklift_id=' + this.selectedForkliftId;
        cont++;
      }
    }

    if (this.selectedBranchOfficeId != 0) {
      if (cont > 0) {
        params = params + '&&branch_office_id=' + this.selectedBranchOfficeId;
      } else {
        params = params + 'branch_office_id=' + this.selectedBranchOfficeId;
        cont++;
      }
    }

    if (this.selectedUserId != 0) {
      if (cont > 0) {
        params = params + '&&user_id=' + this.selectedUserId;
      } else {
        params = params + 'user_id=' + this.selectedUserId;
        cont++;
      }
    }

    return params;
  }

  /*
    TODO: implementar la llamada al servicio de preliquidaciones (PresettlementService).
    Mientras tanto el listado queda vacío, la estructura del módulo ya está lista. */
  loadPresettlements(params: string) {
    console.log('.---------->' + params);
    this.rowsClient = [];
    swal.close();
  }

  toUTC(dateStr: string) {
    const localDate = new Date(dateStr.replace(' ', 'T'));
    return new Date(
      localDate.getTime() + localDate.getTimezoneOffset() * 60000
    ).toISOString().slice(0, 19).replace('T', ' ');
  }

  createPresettlement() {
    this.router.navigateByUrl('maintenance/presettlementCustomer');
  }

  updatePresettlement(row: any) {
    this.router.navigateByUrl('maintenance/presettlementCustomerUpdate/' + row.id);
  }

  /*
    TODO: implementar la generación del PDF de la preliquidación, depende de los
    detalles de la preliquidación que aún no están disponibles en el servicio. */
  downloadPdf(row: any) {
    console.log(row);
  }
}



// WEBPACK FOOTER //
// ./src/app/master/master-presettlement-all/master-presettlement-all.component.ts